export default function BrandMark({ className = '' }) {
  return (
    <svg className={`brand-mark ${className}`.trim()} viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      <circle className="brand-mark__sphere" cx="16" cy="16" r="10.5" />
      <circle className="brand-mark__core" cx="16" cy="16" r="1.9" />
    </svg>
  );
}
